<mat-card class="leaderboard-card">
    <mat-card-title *ngIf="!message">
        <button mat-icon-button color="primary" *ngIf="hide" (click)="hideLeaderboardPreview()">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
        <div class="title" i18n="@@leaderboardService-title">Scores</div>
        <button mat-raised-button color="primary" *ngIf="!revealed" (click)="showLeaderboard()" i18n="@@leaderboardService-revealToEveryone">Révéler à tous</button>
        <button mat-raised-button color="primary" *ngIf="hide && revealed" (click)="hideLeaderboard()" i18n="@@leaderboardService-hideForEveryone">Cacher à tous</button>
    </mat-card-title>
    <mat-card-title *ngIf="message">{{message}}&nbsp;
        <button mat-raised-button color="primary" *ngIf="!revealed" (click)="showLeaderboard()" i18n="@@leaderboardService-revealToEveryone">Révéler à tous</button>
        <button mat-raised-button color="primary" *ngIf="hide && revealed" (click)="hideLeaderboard()" i18n="@@leaderboardService-hideForEveryone">Cacher à tous</button>
    </mat-card-title>
    <mat-card-subtitle i18n="@@leaderboardService-subtitleTeams">{playerCount, plural, =0 {Pas de joueur} =1 {<span i18n="@@leaderboardService-onePlayer">1 joueur</span>} autre {{{playerCount}} <span i18n="@@leaderboardService-playersCount">joueurs</span>}}</mat-card-subtitle>
    <mat-card-content class="content">
        <mat-list>
            <mat-list-item class="header">
                <div class="header-position">#</div>
                <div class="header-player" i18n="@@leaderboardService-serviceHeader">Groupe</div>
                <div class="header-playercount" i18n="@@leaderboardService-playersHeader">Joueurs</div>
                <div class="header-score" i18n="@@leaderboardService-scoreHeader">Score</div>
            </mat-list-item>
            <cdk-virtual-scroll-viewport itemSize="110" class="example-viewport">
                <app-service-leaderboard-entry class="example-item" *cdkVirtualFor="let i = index; let item of ds"
                                               [entry]="item" [ranking]="i"></app-service-leaderboard-entry>
            </cdk-virtual-scroll-viewport>
            <mat-divider></mat-divider>
        </mat-list>
    </mat-card-content>
</mat-card>
